import { registerStore } from '../../common/utilsClient/multiReducer';

const store = registerStore({
  path: 'ui.screens.ProjectsDashboard',
  initialState: {
    cards: {},
    dashboards: {},
    dialogs: {},
    activePatientId: null,
    activeMilestoneId: null,
    activeActivityId: null,
    activeAnswersSheetId: null,
    activeNoteId: null,
    editNoteDialogVisible: false,
    editMilestoneDialogVisible: false,
    milestoneDialogVisible: false,
    milestoneDialogActiveKey: 'questionnaires',
    answersSheetDialogVisible: false,
    remindersDialogVisible: false,
    addAnswersSheetsDialogVisible: false,
    removeAnswersSheetDialogVisible: false,
    previewPatientResponseDialogVisible: false,
    tabs: [],
  },
});

export default store;
